import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { MailingAttachmentStatusEnum } from '@zaoblako/shared/modules/notification/enums/mailing-attachment-status.enum';
import { MailingAttachmentStatusEnumI18n } from '@zaoblako/shared/modules/notification/i18n/mailing-attachment-status-enum.i18n';

@Pipe({
  name: 'mailingAttachmentStatusName',
  standalone: true
})
export class MailingAttachmentStatusNamePipe implements PipeTransform {
  public transform(status: MailingAttachmentStatusEnum): string {
    return MailingAttachmentStatusEnumI18n[I18nLocalesEnum.RU_RU][status] || '';
  }
}
